import PasteSvg from '@assets/images/svg/paste.svg';
import React from 'react';
import { View } from 'react-native';

export interface PasteIconProps {
    size?: number;
    color?: string;
}

export function PasteIcon({ size = 20, color = '#333333' }: PasteIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <PasteSvg width={size} height={size} color={color} />
        </View>
    );
}

